import React, {
 createContext, useState, useEffect, useMemo, 
} from 'react';
import PropTypes from 'prop-types';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [restaurantid, setRestaurantId] = useState('');
  const [userid, setUserId] = useState('');
  const [statusCode, setStatusCode] = useState('');
  const [type, setType] = useState('');
  const [currencyCode, setCurrencyCode] = useState('');
  const [countryId, setCountryId] = useState('');
   const [apiGlobal, setApiGlobal] = useState('https://navrang.mvd-tech.io/API/');// development
   
  // const [apiGlobal, setApiGlobal] = useState('https://admin.bitevize.com/API/'); // production

  const value = useMemo(() => ({ 
    isLoggedIn, 
    setIsLoggedIn, 
    username, 
    setUsername,
    apiGlobal,
    setApiGlobal,
    restaurantid, 
    setRestaurantId,
    userid, 
    setUserId,
    statusCode, 
    setStatusCode,
    type,
    setType,
    currencyCode, 
    setCurrencyCode,
     countryId,
      setCountryId,
  }), [isLoggedIn, username, apiGlobal, restaurantid, userid, statusCode, type, currencyCode, countryId]);

  return (
    <AuthContext.Provider value={value}>
      {children}
      
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContextProvider;

